import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { PanAppState } from '@panamax/app-state';
import { PlatformService } from '@panamax/app-state';
import { OrderItem } from '@usf/ngrx-order';
import { ProductPropertiesEnum } from '@usf/product-types';
import { Subscription } from 'rxjs';
import { ImageVariantEnum } from 'src/app/product-detail/models/image-variant.enum';
import {
  getCarouselImages,
  getFirstImageURL,
} from 'src/app/product-detail/utils/product-images.util';
import { QuantityUpdate } from 'src/app/shared/models/quantity-update';
import { PlatformEnum } from '../../../shared/constants/platform-type.enum';
import { ApiUpdatable } from '../../../shared/models/api-updatable';
import { Product } from '../../../shared/models/product.model';
import { SearchService } from '../../services/search.service';
import { ImageModel } from '@shared/models/image.model';
import { UsfProductCardModeEnum } from '@shared/constants/usf-product-card-mode.enum';
import { ProductCompareEnum } from '@shared/constants/product-compare.enum';

@Component({
  selector: 'app-product-card-popover',
  templateUrl: './product-card-popover.component.html',
  styleUrls: ['./product-card-popover.component.scss'],
})
export class ProductCardPopoverComponent implements OnInit {
  @Input() product: Product;
  @Input() pricingDisabled: boolean;
  @Input() quantityInputsDisabled: boolean;
  @Input() platformEnum: PlatformEnum;
  @Input() quantityEach: ApiUpdatable<number>;
  @Input() quantityUnit: ApiUpdatable<number>;
  @Input() mode: UsfProductCardModeEnum;
  @Output() quantityUpdateEmitter = new EventEmitter<QuantityUpdate>();
  @Input() navigationDisabled = true;
  thumbnailImageURL: string;
  alternativeImageUrl: ImageModel[];
  productDescriptionNotAvailableMessage: string;
  productBrandNotAvailableMessage: string;
  propertiesEnum = ProductPropertiesEnum;
  constructor(
    readonly platformService: PlatformService,
    readonly panAppState: PanAppState,
    private searchService: SearchService,
  ) {}

  ngOnInit() {
    this.thumbnailImageURL = getFirstImageURL(
      this.product?.summary,
      ImageVariantEnum.Thumbnail,
    );
    this.alternativeImageUrl = getCarouselImages(this.product?.summary);
  }

  getAlternativeThumbnail(imageUrl: string): string {
    const availImages = this.alternativeImageUrl?.find(
      (v, i) => v.urls.Thumbnail != imageUrl,
    );
    return availImages?.urls.Thumbnail;
  }

  updateQuantity(event: QuantityUpdate) {
    this.quantityUpdateEmitter.emit(event);
  }

  get productRoute(): string | any[] {
    return !this.isExceptionSubCompare
      ? ['/desktop/products', this.product?.productNumber]
      : null;
  }
  get isExceptionSubCompare(): boolean {
    return (this.mode as any) === ProductCompareEnum.exceptionSubCompare;
  }
}
